// @flow
import React, { PureComponent, Fragment } from 'react';
import type { ThemeType, QuestionType } from 'types/Faq';
import { dynamicClassName } from 'utils/dynamicClassName';
import { Link } from 'react-router-dom';

export type StateProps = {
  themes?: Array<ThemeType>,
  questions: Array<QuestionType>
};

type Props = {
  match: {
    params: {
      slugTheme: string
    }
  },
  validSearch: string
} & StateProps;

type State = {
  isOpen: boolean
};

class FaqThemeList extends PureComponent <Props, State>{
  wrapperRef: any;
  state: State = {
    isOpen: false
  };

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  setWrapperRef = (node: any) => {
    this.wrapperRef = node;
  };

  handleClickOutside = (event: MouseEvent) => {
    if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
      this.setState({ isOpen: false });
    }
  };

  renderTheme = () => {
    const { themes, validSearch, questions } = this.props;
    const { slugTheme } = this.props.match.params;
    let first = 0;
    if (themes) {
      return themes.map<any>((theme, index) => {
        const aClassName = dynamicClassName('ft-h6 js-issues-link');
        const filteredQuestions = questions.filter(question => question.theme === theme.id);

        if (filteredQuestions.length === 0) {
          return null;
        }

        if (
            (
              (!slugTheme && first === 0)
              || theme.slug === slugTheme
            )
            && validSearch === ''
        ) {
          aClassName.add('is-active');
          first = 1;
        }
        return <Link key={index} to={`/faq/${theme.slug}`} className={aClassName.build()}>{theme.name}</Link>;
        }
      );
    }
    return null;
  };

  renderDropdown = () => {
    const { themes, questions } = this.props;
    const { slugTheme } = this.props.match.params;

    if ((!themes || themes.length === 0) && (!questions || questions.length === 0)) {
      return (
        <Fragment>
          <span className="dropdown__head ft-h6 ft-up">
            <span className="dropdown__label"></span>
          </span>
          <div className="dropdown__list">
            <span className="dropdown__head ft-h6 ft-up">
              <span className="dropdown__label"></span>
            </span>
          </div>
        </Fragment>
      );
    }

    const filteredThemes = themes ? themes.filter(theme => {
      const filteredQuestions = questions ? questions.filter(question => question.theme === theme.id) : [];
      if (filteredQuestions.length === 0) {
        return false;
      }
      return true;
    }) : [];

    if (filteredThemes.length === 0) {
      return (
        <Fragment>
          <span className="dropdown__head ft-h6 ft-up">
            <span className="dropdown__label"></span>
          </span>
          <div className="dropdown__list">
            <span className="dropdown__head ft-h6 ft-up">
              <span className="dropdown__label"></span>
            </span>
          </div>
        </Fragment>
      );
    }

    let selectedTheme = filteredThemes.filter(theme => theme.slug === slugTheme);

    if (selectedTheme.length === 0) {
      selectedTheme[0] = filteredThemes[0];
    }

    return (
      <Fragment>
        <span className="dropdown__head ft-h6 ft-up" onClick={this.handleClickDropDown}>
          <span className="dropdown__label">{selectedTheme[0].name}</span>
        </span>
        <div className="dropdown__list">
          <span className="dropdown__head ft-h6 ft-up" onClick={this.handleClickDropDown}>
            <span className="dropdown__label">{selectedTheme[0].name}</span>
          </span>
          <div className="dropdown__wrapper">
            {filteredThemes.map((theme, index) => {
              return (
                <div className="radio " key={index}>
                  <input name="as73d" type="radio" id="as73dadersf"/>
                  <label htmlFor="as73dadersf" onClick={this.handleClickDropDown}>
                    <Link to={`/faq/${theme.slug}`}>{theme.name}</Link>
                  </label>
                </div>
              );
              }
            )}
          </div>
        </div>
      </Fragment>
    );
  };


  handleClickDropDown = (e: MouseEvent) => {
    this.setState(prevState => ({
      isOpen: !prevState.isOpen
    }));
  };

  render(){
    const { themes, questions } = this.props;

    if (!themes) {
      return null;
    }

    const options = [];
    themes.forEach(theme => {
      const filteredQuestions = questions.filter(question => question.theme === theme.id);
      if (filteredQuestions.length === 0) {
        return null;
      }
      options.push({label: theme.name, value: theme.slug});
    });

    const classNames = dynamicClassName('dropdown dropdown--radio dropdown--navbar');
    this.state.isOpen && classNames.add('is-open');
    return (
      <div className="block-faq__header col-md-4 col-lg-3 mb-4">
        <div>
          {this.renderTheme()}
          <i className="icon icon-arrow-triangle-bottom"></i>
        </div>
        <div className={classNames.build()} ref={this.setWrapperRef}>
          {this.renderDropdown()}
        </div>
      </div>
    );
  }
}

export default FaqThemeList;
